<!-- 首页 -->
<template>
	<div class="container flex flex-column height-all">
		<!-- 顶部搜索模块 -->
		<div class="searchContainer flex-shrink">
			<baseSearch :searchData="searchData" :isShowExport="true" @searchClick="searchBtnClick" @exportClick="exportBtnClick" />
		</div>
		<!-- 剩余面单数量 -->
		<div class="remainderOrderNum">
			剩余面单数量&nbsp;&nbsp;
			<template v-for="item in remainderOrderNum">
				{{item.expressName + '：' + item.count}} &nbsp;&nbsp;
			</template>
		</div>
		<!-- 按钮 -->
		<div class="btnWarp flex-shrink">
			<!--      <el-button type="primary" @click="intimidateOrder($event)">打单</el-button>-->
			<el-button type="primary" @click="expressageClick($event)">打单</el-button>
		</div>
		<!-- 主体表格 -->
		<div class="mainTable height-all overflow-hidden">
			<basetable tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="basetableinfo" :showopera="isShowopera" :currentPage="searchDataParam.pageNo" :operaWidth="operaWidth" :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true" :showSelection="true" :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick" @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
				<template v-slot:linkCount="scope">
					<div class="progressBox" v-if="scope.scope.row.percentage != -1">
						<el-progress type="circle" :percentage="scope.scope.row.percentage" :width="20" :stroke-width="3" :show-text="false" color="#4A7FF8"></el-progress>
						<span>{{scope.scope.row.linkCountText}}</span>
					</div>
				</template>
				<template v-slot:opera="scope">
					<template v-for="(item, index) in scope.scope.row.expressModeArr" :key="index">
						<el-button v-if="item.code == '1'" type="primary" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
						<el-button v-else-if="item.code == '5'" type="success" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
						<el-button v-else-if="item.code == '0'" type="warning" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
						<el-button v-else-if="item.code == '7'" type="info" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
						<el-button v-else-if="item.code == '2'" type="danger" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
						<el-button v-else type="primary" size="small" @click="changeExpressItem(scope.scope, item.code,$event)">{{'打印' + item.name}}</el-button>
					</template>
					<!-- <el-button  plain type="primary" size="small" class="tableOptionBtn" @click="changeExpressItem(scope.scope, item.code,$event)" v-for="(item, index) in scope.scope.row.expressModeArr" :key="index">{{'打印' + item.name}}</el-button> -->
				</template>
			</basetable>
		</div>
	</div>
	<!-- 添加区域弹窗 -->
	<basedialog title="更换快递" :dialogVisible="isShowOrderDetailsCover" dialogWidth="600" @dialogConfirm="dialogConfirm" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose">
		<template #dialogbody>
			<div class="addAreaCoverDiv flex justify-center flex-warp">
				<el-form ref="expressModeForm" :rules="expressModeRules" v-model="formData" class="addAreaForm">
					<el-form-item label="快递方式: " prop="areaInfoArr" class="flex align-center">
						<el-select v-model="formData.expressModeArr" filterable class="m-2" placeholder="请选择快递方式">
							<el-option v-for="item in expressModeOptions" :key="item.code" :label="item.name" :value="item.code" />
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</template>
	</basedialog>
	
	<!-- 正在打印快递单 -->
	<basedialog title="" :dialogVisible="isShowPrintIngCover" :showFooter="false" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false" center="true" dialogWidth="350" @dialogConfirm="dialogConfirm" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose">
		<template #dialogbody>
			<div class="flex justify-center flex-column align-center">
				<div class="printIngDiv">
					<img v-if="printIngInfo.errorCount == 0" src="@/static/images/icon_printIng.png" alt="" />
					<el-icon v-if="printIngInfo.errorCount > 0"><WarningFilled /></el-icon>
					<span>{{printIngInfo.errorCount == 0 ? '打单中，请稍候...' : '打单异常，请重新打单'}}</span>
				</div>
				<span v-if="printIngInfo.errorCount == 0" class="printIngCount">{{printIngInfo.successCount + '/' + printOrderData.length}}</span>
				<span v-if="printIngInfo.errorCount > 0" class="printIngCount">{{'已打单' + printIngInfo.successCount + '个'}}</span>
			</div>
			<div class="dialog-footer" style="justify-content: center;align-items: flex-end;">
				<el-button size="large" @click="closePrintIng">{{printIngInfo.errorCount == 0 ? '取消打印' : '关闭'}}</el-button>
			</div>
		</template>
	</basedialog>
</template>

<script>
	import baseSearch from "@/components/baseSearch"
	import basetable from "@/components/basetable"
	import basedialog from "@/components/basedialog"
	import preview from '@/utils//juageProType.js'
	import tableDataSelect from "@/components/tableDataSelect"
	import utils from "../../utils/utils";

	export default {
		inject: ['$http', '$api', '$utils', '$userUtils'],
		name: "orderList",
		components: {
			baseSearch,
			basetable,
			basedialog,
			tableDataSelect,
		},
		data() {
			return {
				isShowopera: false,
				operaWidth:200,
				searchData: [{
					label: "订单号",
					type: "input",
					name: "orderSId",
					value: ""
				}, {
					label: "卡片打单时间",
					type: "datetimerange",
					name: "sendTime",
					value: [],
				}, {
					label: "抖音支付时间",
					type: "datetimerange",
					name: "dyPayTime",
					value: [],
				}, {
					label: "是否已发货",
					type: "select",
					name: "isSend",
					options: [{
						label: "是",
						value: '1'
					}, {
						label: "否",
						value: '0'
					}],
				}],
				isLoading: false,
				tableTitle: [{
					label: '订单号',
					prop: 'orderSId',
					width: 180
				}, {
					label: '抖音产品名称',
					prop: 'proName',
					width: 220
				}, {
					label: '抖音支付时间',
					prop: 'orderPayTime',
					width: 180
				}, {
					label: '卡片打单时间',
					prop: 'sendCardTime',
					width: 220
				}, {
					label: '快递公司',
					prop: 'cardExpressName',
					width: 120
				}, {
					label: '快递单号',
					prop: 'cardExpressNum',
					width: 180
				}],
				basetableinfo: [],
				expressModeOptions: [], //快递方式options
				remainderOrderNum: [], //中通剩余单量
				orderIds: [],
				total: 0,
				searchDataParam: {
					orderNo: "", //订单号
					productName: "", //产品名称
					sendTime: "", //卡片打单时间
					dyPayTime: "", //抖音支付时间
					expressMode: [], //快递方式
					orderType: "", //订单类型
					pageNo: 1,
					pageSize: 20
				},
				isShowOrderDetailsCover: false, //是否显示订单详情遮罩层
				orderDetailsInfo: {}, //订单详情
				isShowExport: true,
				expressModeRules: {
					"expressModeArr": [{
						required: true,
						message: "请选择快递方式",
						trigger: "change"
					}],
				},
				formData: {
					expressModeArr: "",
				},
				currentChooseOrderIds: [],
				isShowPrintIngCover: false, //是否显示正在打单弹框,
				startPrint: false, //开始打印 true：循环打印，false：暂停打单
				printIngInfo: {
					successCount: 0, //正在打单中成功的数量
					errorCount: 1, //正在打单中失败数量
				},
				mergeOrderType:0,//是否进行批量打单
			}
		},
		mounted() {
			this.searchData[3].value = '0';
			//获取快递方式筛选项
			this.getSupportExpressOptions();

			//创建WebSocket并持续监听打单
			this.createWebSocket();

			// 获取剩余单量
			this.getLogisticsMarginByZt();
		},

		methods: {

			/**
			 * 创建WebSocket
			 */
			createWebSocket() {
				let that = this;
				that.socket = new WebSocket('ws://127.0.0.1:13888');
				console.log("that.socket:::", that.socket);
				// 监听消息
				that.socket.onmessage = function(event) {
					console.log('Client received a message', event);
					let dataStr = event.data;
					if (dataStr != null && dataStr != '') {
						let data = JSON.parse(dataStr);
						if (data.cmd == 'print') { //打印
							if (data.status == 'success') {
								//发货接口是异步操作，所以等待一秒后再刷新列表接口
								//that.getOrderPrintList();
							}
						}
						if (data.cmd == 'notifyPrintResult') { //打印回调
							if (data.status == 'success' && data.taskStatus == 'printed') {
								// that.$message.success("任务id：" + data.taskID + ",打印完成...");
								if(that.mergeOrderType == 1){
									that.confirmPrintOrder(data.printStatus[0].trackNo)
                                    that.$utils.saveServiceLog(1,'打印完成trackNo:'+ data.printStatus[0].trackNo)
								}else{
									this.$loading().close();
									that.$message.success("打印完成");
									this.getOrderPrintList();
								}
							} else {
								if(that.mergeOrderType == 1){
									that.printIngInfo.errorCount += 1;
								}else{
									this.$loading().close();
									that.printIngInfo.errorCount += 1;
									that.$message.error("任务id：" + data.taskID + ",失败原因【" + data.printStatus[0].msg + "】");
								}
                                that.$utils.saveServiceLog(2,'失败'+ data.printStatus[0].trackNo+ ":" + data.toString())
								that.$message.error("任务id：" + data.taskID + ",失败原因【" + data.printStatus[0].msg + "】");
							}
						}
					}
				};
				// 监听Socket的关闭
				that.socket.onclose = function(event) {
					console.log('Client notified socket has closed', event);
				};
			},
			
			/**
			 * 批量打印电子面单打印成功
			 */
			confirmPrintOrder(trackNo) {
				let confirmOrderInfoJson = '';
				let orderInfoJsonList = '';
				for (let i = 0; i < this.printOrderData.length; i++) {
					if (this.printOrderData[i].trackNo == trackNo) {
						this.printIngInfo.successCount += 1;
						if(this.printIngInfo.successCount >= this.printOrderData.length){
							// 打印完成结束打印
							this.$message.success("打印完成");
							if (this.mergeOrderType == 1) {
								setTimeout(()=>{
									this.closePrintIng();
								},1000)
							}else{
								this.$loading().close();
								setTimeout(()=>{
									// 更新列表
									this.getOrderPrintList();
								},1000)
							}
						}else{
							if (this.startPrint) {
								//执行打单操作
								this.generateUUid(this.printOrderData[this.printIngInfo.successCount]);
							} else {
								// 更新列表
								this.getOrderPrintList();
							}
						}
						break;
					}
				}
				
			},
			/**
			 * 获取快递方式筛选项
			 */
			getSupportExpressOptions() {
				let that = this;
				that.$http.post(that.$api.getSupportExpressOptionsApi).then(res => {
					if (res.code == 200) {
						that.expressModeOptions = res.data;
					}
				})
			},
			/**
			 * 获取中通快递剩余单量
			 */
			getLogisticsMarginByZt() {
				let that = this;
				that.$http.post(that.$api.getLogisticsMarginApi).then(res => {
					if (res.code == 200) {
						that.remainderOrderNum = res.data;
					}
				})
			},
			/**
			 * 初始化获取未打印电子面单列表
			 */
			getOrderPrintList() {
				let that = this;
				that.isLoading = true;
				console.log(that.searchDataParam)
				that.$http.postRaw(that.$api.getCardOrderListNewApi, {
					"pageNo": that.searchDataParam.pageNo,
					"pageSize": that.searchDataParam.pageSize,
					"orderSId": that.searchDataParam.orderSId,
					"isSend": that.searchDataParam.isSend,
					"sendStartTime": that.$utils.isEmpty(that.searchDataParam.sendTime) ? "" : that.searchDataParam.sendTime[0],
					"sendEndTime": that.$utils.isEmpty(that.searchDataParam.sendTime) ? "" : that.searchDataParam.sendTime[1],
					"dyPayStartTime": that.$utils.isEmpty(that.searchDataParam.dyPayTime) ? "" : that.searchDataParam.dyPayTime[0],
					"dyPayEndTime": that.$utils.isEmpty(that.searchDataParam.dyPayTime) ? "" : that.searchDataParam.dyPayTime[1],
				}).then(res => {
					that.isLoading = false;
					if (that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;

					that.basetableinfo = res.data.list;

					//遍历数据，重置格式
					if (that.basetableinfo.length > 0) {
						that.basetableinfo.forEach((item, index) => {
							item.orderPayTime = that.$utils.isEmpty(item.orderPayTime) ? "--" : that.$utils.getDateTime(item.orderPayTime);
							item.sendCardTime = that.$utils.isEmpty(item.sendCardTime) ? "--" : that.$utils.getDateTime(item.sendCardTime);

							//遍历数据获取快递方式，并且排除当前订单的快递方式
							item.expressModeArr = [];
							if (that.expressModeOptions.length > 0) {
								/* that.expressModeOptions.forEach((expressItem, expressIndex) => {
									//判断是否需要显示操作列【如果没有其他可改打的快递方式，则屏蔽操作列】
									if (that.expressModeOptions.length == 1 && (expressItem.code == item.usePostal)) {
										that.showopera = false;
										return
									}

									if (expressItem.code != item.usePostal) {
										item.expressModeArr.push(expressItem);
									}
								}) */
								item.expressModeArr = that.expressModeOptions;
								if(!that.isShowopera){
									if (!that.$utils.isEmpty(item.expressModeArr)) {
										that.isShowopera = true
										if(that.expressModeOptions.length == 2){
											that.operaWidth = 300;
										}else if(that.expressModeOptions.length == 3){
											that.operaWidth = 400;
										}else if(that.expressModeOptions.length == 4){
											that.operaWidth = 480;
										}else if(that.expressModeOptions.length >= 5){
											that.operaWidth = 550;
										}
									} else {
										that.isShowopera = false
									}
								}
							}
						})
					}
				})
			},
			/**
			 * 搜索按钮
			 */
			searchBtnClick(option) {
				let that = this;
				this.searchDataParam = Object.assign(this.searchDataParam, option);
				if (!this.$utils.isEmpty(this.searchDataParam.orderSId) || !this.$utils.isEmpty(this.searchDataParam.sendTime) || !this.$utils.isEmpty(this.searchDataParam.dyPayTime) || !this.$utils.isEmpty(this.searchDataParam.isSend)) {
					this.searchDataParam.pageNo = 1;
					this.getOrderPrintList()
				} else {
					this.$message.warning('请输入查询条件')
				}
			},
			/**
			 * 设置页码
			 */
			currentChange(val) {
				this.searchDataParam.pageNo = val;
				this.getOrderPrintList()
			},
			/**
			 * 设置页码
			 */
			sizeChange(val) {
				this.searchDataParam.pageSize = val;
				this.getOrderPrintList()
			},
			/**
			 * 导出
			 */
			exportBtnClick() {
				let that = this;
				this.$confirm('是否只导出当前页？', '提示', {
					confirmButtonText: '是',
					cancelButtonText: '导出全部',
					distinguishCancelAndClose: true, // 重要，设置为true才会把右上角X和取消区分开来
					type: 'warning',
					center: true
				}).then((action) => {
					that.exportSimplePageData();
					console.log('导出当前页')

				}).catch((action) => {
					if (action === 'cancel') {
						console.log('导出全部')
						that.exportAllData();
					}
				});
			},
			/**
			 * 导出当前页
			 */
			exportSimplePageData() {
				let that = this;
				//遍历数据，获取当前要导出的订单ID
				// that.orderIds = [];
				// if(that.productList.length > 0) {
				//   that.productList.forEach((item, index) => {
				//     that.orderIds.push(item.id)
				//   })
				// }
				//导出
				that.exportDyOrder(1);
			},
			/**
			 * 导出全部
			 */
			exportAllData() {
				let that = this;
				that.orderIds = [];
				that.exportDyOrder(0);
			},
			/**
			 * 导出数据
			 * @param {Object} type  1：导出当前页     0：导出全部
			 */
			exportDyOrder(type) {
				let that = this;
				that.$loading();
				that.$http.post(that.$api.exportCardOrderListNewApi, {
					"pageNo": that.searchDataParam.pageNo,
					"pageSize": that.searchDataParam.pageSize,
					"orderSId": that.searchDataParam.orderSId,
					"isSend": that.searchDataParam.isSend,
					"sendStartTime": that.$utils.isEmpty(that.searchDataParam.sendTime) ? "" : that.searchDataParam.sendTime[0],
					"sendEndTime": that.$utils.isEmpty(that.searchDataParam.sendTime) ? "" : that.searchDataParam.sendTime[1],
					"dyPayStartTime": that.$utils.isEmpty(that.searchDataParam.dyPayTime) ? "" : that.searchDataParam.dyPayTime[0],
					"dyPayEndTime": that.$utils.isEmpty(that.searchDataParam.dyPayTime) ? "" : that.searchDataParam.dyPayTime[1],
					"expFlag": type,
				}).then(res => {
					that.$loading().close();
					if (res.code == 200) {
						that.$message.success("导出成功，请到我的文件查看");
					}
				})
			},
			/**
			 * 关闭地址选择
			 */
			dialogClose() {
				this.isShowOrderDetailsCover = false;
			},
			/**
			 * 复选框
			 */
			selectionChange(val) {
				this.currentChooseOrderIds = val;
				console.log(val)
			},
			/**
			 * 更换快递遮罩
			 */
			expressageClick(evt) {
				let target = evt.target;
				if (target.nodeName == "SPAN") {
					target = evt.target.parentNode;
				}
				target.blur();
				let that = this;
				if (that.currentChooseOrderIds.length == 0) {
					that.$message.warning("请选择要更换的订单");
					return
				}

				that.formData.expressModeArr = "";
				this.isShowOrderDetailsCover = true;
			},
			/**
			 * 更换快递
			 */
			dialogConfirm() {
				let that = this;
				if (that.$utils.isEmpty(that.formData.expressModeArr)) {
					that.$message.warning("请选择快递方式");
					return
				}
				let orderIds = [];
				console.log(that.formData)

				that.currentChooseOrderIds.forEach((item) => {
					orderIds.push(item.orderSId)
				})
				that.$loading();
				that.$http.postRaw(that.$api.batchPrintCardOrderNewApi, {
					"orderIds": orderIds.toString(),
					"usePostal": that.formData.expressModeArr.toString()
				}).then(res => {
					that.confirmLoading = false;
					that.$loading().close();
					if (res.code) {
						that.isShowOrderDetailsCover = false;
						// that.searchDataParam.pageNo = 1;
						// that.getOrderPrintList();
						//执行打单操作
						// that.printDoOrder(res.data);
						that.printOrderData = res.data;
						that.printIngInfo.successCount = 0;
						that.printIngInfo.errorCount = 0;
						that.mergeOrderType = 1;
						if (that.printOrderData != null && that.printOrderData.length > 0) {
							that.startPrint = true;
							that.isShowPrintIngCover = true;
							//执行打单操作
							that.generateUUid(that.printOrderData[that.printIngInfo.successCount]);
						} else {
							that.$message.error("未获取到打单信息");
						}
					}
				}).catch(err => {
					that.confirmLoading = false;
				})
			},
			/**
			 * 切换快递按钮点击事件
			 * @param {Object} scope
			 */
			changeExpressItem(scope, code, evt) {
				let target = evt.target;
				if (target.nodeName == "SPAN") {
					target = evt.target.parentNode;
				}
				target.blur();
				let that = this;
				let orderIds = [];
				orderIds.push(scope.row.orderSId)
				that.$loading();
				console.log(scope)

				that.$http.postRaw(that.$api.batchPrintCardOrderNewApi, {
					"orderIds": orderIds.toString(),
					"usePostal": code.toString()
				}).then(res => {
					that.$loading().close();
					if (res.code == 200) {
						let resultData = res.data;

						//执行打单操作
						that.printDoOrder(resultData);
					}
				})
			},
			/**
			 * 打单按钮点击事件
			 */
			intimidateOrder(evt) {
				let target = evt.target;
				if (target.nodeName == "SPAN") {
					target = evt.target.parentNode;
				}
				target.blur();
				let that = this;
				if (that.currentChooseOrderIds.length > 0 || !this.$utils.isEmpty(that.searchDataParam.orderNo) || !this.$utils.isEmpty(that.searchDataParam.productionBatch) || !this.$utils.isEmpty(that.searchDataParam.productionAccount) || !this.$utils.isEmpty(that.searchDataParam.productionCode) || !this.$utils.isEmpty(that.searchDataParam.productionTime[0]) || !this.$utils.isEmpty(that.searchDataParam.expressMode) || !this.$utils.isEmpty(that.searchDataParam.orderType)) {
					let orderIds = [];
					console.log(that.formData)

					that.currentChooseOrderIds.forEach((item) => {
						orderIds.push(item.id)
					})

					that.$loading();
					that.$http.postRaw(that.$api.printOrderApi, {
						"orderNo": that.searchDataParam.orderNo.toString(),
						"queryType": "noPrint", //noPrint 未打单 noSend 未发货  send 已发货
						"productBatch": that.searchDataParam.productionBatch.toString(),
						"productAccount": that.searchDataParam.productionAccount.toString(),
						"productNum": that.searchDataParam.productionCode.toString(),
						"productStartTime": that.$utils.isEmpty(that.searchDataParam.productionTime) ? "" : that.searchDataParam.productionTime[0],
						"productEndTime": that.$utils.isEmpty(that.searchDataParam.productionTime) ? "" : that.searchDataParam.productionTime[1],
						"express": that.searchDataParam.expressMode.toString(),
						"orderType": that.searchDataParam.orderType.toString(),
						"orderIds": orderIds.toString(),
					}).then(res => {
						if (res.code == 200) {
							let resultData = res.data;
							//执行打单操作
							that.printDoOrder(resultData);
						} else {
							that.$loading().close();
						}
					})
				} else {
					that.$message.warning("请选择要打印的订单");
					return
				}
			},
			/**
			 * 正在打单弹框点击取消打单
			 */
			closePrintIng() {
				this.startPrint = false;
				this.isShowPrintIngCover = false;
				this.mergeOrderType = 0;
				console.log('点击暂停打印了')
				// 更新列表
				this.getOrderPrintList();
			},
			/**
			 * 执行打单操作
			 * @param {Object} resultData
			 */
			printDoOrder(resultData) {
				let that = this;
				if (resultData != null && resultData.length > 0) {
					resultData.forEach((item, index) => {
						console.log(item)
						that.generateUUid(item);
					})
				} else {
					that.$message.error("未获取到打单信息");
				}
			},
			/**
			 * 获取UUID
			 */
			getUUID(len, radix) {
				var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
				var uuid = [],
					i;
				radix = radix || chars.length;
				if (len) {
					for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
				} else {
					var r;
					uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
					uuid[14] = '4';
					for (i = 0; i < 36; i++) {
						if (!uuid[i]) {
							r = 0 | Math.random() * 16;
							uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
						}
					}
				}
				return uuid.join('');
			},

			/**
			 * 获取UUID
			 */
			generateUUid(item) {
				let that = this;

				let order_no = item.orderNo;
				let track_no = item.trackNo;
				let params = item.param;
				let sign = item.sign;
				let printer = item.printer;
				let print_data = item.printerData;
				let product_num = item.productNum;
				let product_name = item.productName;
				let product_count = item.productCount;
				let logistics_code = item.logisticsCode;
				let baseTemplateUrl = item.baseTemplateUrl;
				let templateUrl = item.templateUrl;
                that.$utils.saveServiceLog(1,'开始打单trackNo:' + item.trackNo)
				console.log(order_no)
				that.doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer);
			},
			/**
			 * 发送打印数据
			 * @param {Object} order_no
			 * @param {Object} track_no
			 * @param {Object} params
			 * @param {Object} sign
			 * @param {Object} print_data
			 * @param {Object} product_num
			 * @param {Object} product_name
			 * @param {Object} product_count
			 * @param {Object} baseTemplateUrl
			 * @param {Object} templateUrl
			 * @param {Object} printer
			 */
			doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer) {
				let that = this;
				let request = {
					cmd: "print",
					requetID: that.getUUID(8, 16),
					version: "1.0",
					task: {
						"taskID": that.getUUID(8, 16),
						"printer": printer,
						"documents": [{
							"documentID": track_no, //运单号，可选
							"contents": [{
								"params": params,
								"signature": sign,
								"encryptedData": print_data,
								"templateURL": baseTemplateUrl,
								"addData": {
									"senderInfo": {
										"address": {
											"cityName": "石家庄市",
											"countryCode": "CHN",
											"detailAddress": "ICC环球智汇中心写字楼C座809",
											"districtName": "裕华区",
											"provinceName": "河北省"
										},
										"contact": {
											"mobile": "0311-88898111",
											"name": "美印兔兔"
										}
									}
								},
								"config": {
									"printlogo": true
								}
							}, {
								//自定义模板，如果没有，就不要传此对象
								"data": {
									"productInfo": product_name,
									"shopName": order_no,
									"orderId": product_num,
									"productCount": product_count + '件'
								},
								"templateURL": templateUrl
							}]
						}]
					}
				};
				// that.$loading().close();
				that.socket.send(JSON.stringify(request));
			},
		},
	}
</script>
<style>
	html,
	body {
		min-width: 900px !important;
	}
</style>
<style scoped>
	.mainCont .container {
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 12px;
		box-sizing: border-box;
	}

	.remainderOrderNum {
		font-size: 14px;
		color: #333;
		line-height: 30px;
		background-color: #fff;
		padding-left: 12px;
		box-sizing: border-box;
		font-weight: 600;
		margin-bottom: 16px;
	}

	/* 订单详情遮罩层 */
	.orderDetailsDiv {
		width: 500px !important;
	}

	.orderDetailsInfo {
		overflow: auto;
		font-size: 13px;
		/*margin: 0 20px 30px;*/
		max-height: 750px;
		overflow-y: scroll;
	}

	.orderDetailsInfoItem {
		width: 100%;
		margin-top: 12px;
		overflow: auto;
	}

	.orderDetailsInfoItem span {
		width: 90px;
		display: inline-block;
		float: left;
		color: #666;
		line-height: 22px;
	}

	.orderDetailsInfoItem p {
		width: calc(100% - 90px);
		font-size: 13px;
		float: left;
		word-break: break-all;
		line-height: 22px;
	}



	/* 导出遮罩层 */
	.exportDataCover,
	.orderDetailsCover {
		background-color: rgba(0, 0, 0, .5);
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.exportDataDiv,
	.orderDetailsDiv {
		width: 400px;
		padding: 10px;
		background-color: #fff;
		box-sizing: border-box;
		border-radius: 5px;
		animation: fadeInDown 0.5s;
	}

	.coverTitle {
		text-align: center;
		font-size: 16px;
		color: #000;
		line-height: 40px;
	}

	.closeCoverDiv {
		width: 30px;
		height: 30px;
		top: 15px;
		right: 15px;
		cursor: pointer;
	}

	.closeCoverDiv img {
		width: 20px;
	}

	.coverDesc {
		padding: 0 15px;
		line-height: 20px;
		font-size: 14px;
		text-align: center;
		margin: 30px 0 40px;
	}

	.coverOptionBtn {
		margin-bottom: 20px;
	}

	.coverOptionBtn button {
		width: 90px;
		height: 35px;
		padding: 0 !important;
		text-align: center;
	}

	.coverOptionBtn button.cancelBtn {
		background: none !important;
		color: #009688 !important;
	}

	.intimidateBtn {
		background-color: #FFB800 !important;
		border-color: #FFB800 !important;
	}

	.changeExpressBtn {
		background-color: #1E9FFF !important;
		border-color: #1E9FFF !important;
	}

	.exportBtn {
		background: #2F4056 !important;
		border-color: #2F4056 !important;
	}
	
	.printIngDiv {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		color: #333333;
	}
	
	.printIngDiv img {
		width: 18px;
		margin-right: 10px;
	}
	
	.printIngCount {
		font-size: 16px;
		color: #666666;
		margin-top: 20px;
	}
	
	.printIngDiv .el-icon{
		margin-right: 10px;
		
		color: #ff0000;
	}
</style>